/* Functions */
( function( $ ) {
    var age_gate = getCookie('confirmed_age')
    var cookie_gate = getCookie('accepted_cookies')
    var accepted_google = getCookie('accepted_google_tracking')
    var accepted_facebook = getCookie('accepted_facebook_tracking')

    /* Check for age gate and cookie gate */
    checkGates();

    function checkGates() {
        if (age_gate == 'true') {
            $('.age-gate').remove()
        }

        if (cookie_gate == 'true' && accepted_google != null && accepted_facebook != null) {
            $('.cookie-gate').remove()
            $('body').removeClass('has-overlay')
            
            setTimeout(function() {
                $('.module-herostage .container').addClass('animate')
            }, 400)
        }

        /* Preload */
        $('.preload-overlay').addClass('fade-out')
        doTracking();

        /* Competition detail animation */
        $('h2').addClass('animate');

        setTimeout(function() {
            $('.preload-overlay').remove()
        }, 400)
    }

    /* Age gate */
    $('.age-gate a').on('click', function() {
        if ($(this).attr('data-age-gate-type') == 'true') {
            /* Set cookie */
            var date = new Date()
            date.setDate(date.getDate() + 14)
            document.cookie = "confirmed_age=true; expires="+date.toUTCString()

            /* Hide age gate */
            $('.age-gate').animate({
                opacity: 0
            }, 200, function() {
                $('.age-gate').remove()
            });
            return false;
        }
    });

    $('.cookie-gate a').on('click', function() {
        if ($(this).attr('data-cookie-gate-type') == 'true') {
            /* Set cookie */
            var date = new Date();
            date.setDate(date.getDate() + 14)
            document.cookie = "accepted_cookies=true; expires="+date.toUTCString()

            if ($('#opt-in-google-tracking').is(':checked') == true) {
                document.cookie = "accepted_google_tracking=true; expires="+date.toUTCString()
            } else {
                document.cookie = "accepted_google_tracking=false; expires="+date.toUTCString()
                window['ga-disable-UA-1652039-15'] = true
            }

            if ($('#opt-in-facebook-tracking').is(':checked') == true) {
                document.cookie = "accepted_facebook_tracking=true; expires="+date.toUTCString()
            } else {
                document.cookie = "accepted_facebook_tracking=false; expires="+date.toUTCString()
            }

            /* Hide age gate */
            $('.cookie-gate').animate({
                opacity: 0
            }, 200, function() {
                $('body').removeClass('has-overlay')
                $('.module-herostage .container').addClass('animate')
                $('.cookie-gate').remove()
            });
            return false;
        }
    });
    
    function getCookie(name) {
        var re = new RegExp(name + "=([^;]+)")
        var value = re.exec(document.cookie)
        return (value != null) ? unescape(value[1]) : null
    }

    function doTracking() {
        doFacebookTracking()
        doGoogleTracking()
    }

    function doFacebookTracking() {
        if (accepted_facebook == 'true') {
            fbq('consent', 'grant')
            fbq('init', '2949053428485080')
            fbq('track', 'PageView')
        } else {
            fbq('consent', 'revoke')
        }
    }

    function doGoogleTracking() {
        if (accepted_google == 'true') {
            gtag('js', new Date());
    		gtag('config', 'UA-1652039-15')
        } else {
            if (window['ga-disable-UA-1652039-15'] != true) {
                window['ga-disable-UA-1652039-15'] = true
            }
        }
    }
})( $ );
